<template>
    <div
      class="inline-flex items-center hover:text-indigo-500 cursor-pointer"
      @click="emitter.emit('openCart')"
    >
        <div class="relative py-2">
            <div v-if="$page.props.cartProductsCount"
                 class="absolute inline-flex items-center justify-center w-6 h-6 pt-0.5 text-xs text-white bg-red-500 border-white rounded-full -top-1 -right-3 dark:border-gray-900">
                {{ $page.props.cartProductsCount }}
            </div>

            <Cart class="w-6"/>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import Cart from '@/Components/Svg/Cart.svg';

export default defineComponent({
    components: { Cart }
})
</script>
